export var SeverityLevels = ['fatal', 'error', 'warning', 'log', 'info', 'debug', 'critical']; //# sourceMappingURL=enums.js.map